import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ReadinessStore } from '../stores/readiness.store';

/**
 * Decides where an admin lands: the setup checklist while the venue is not yet visible to players,
 * the calendar once it is.
 *
 * Sits on the empty path only, so the readiness call happens on landing rather than on every
 * navigation. Unlike the other guards it cannot read a JWT claim — readiness is server state — so it
 * loads the store, which caches for the session.
 *
 * It never returns `false`. A failed readiness read is informational; letting it block navigation
 * would lock an owner out of their own admin app over a status call, which is far worse than the
 * problem this checklist exists to solve. On error the owner lands on the calendar exactly as before.
 */
export const onboardingRedirectGuard: CanActivateFn = async () => {
  const readinessStore = inject(ReadinessStore);
  const router = inject(Router);

  await readinessStore.load();

  const readiness = readinessStore.readiness();
  const needsSetup = !readinessStore.error() && readiness !== null && !readiness.isVisibleToPlayers;

  return router.createUrlTree([needsSetup ? '/setup' : '/calendar']);
};
